import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AddressModel } from '../../../../_models/address';

@Component({
    selector: 'customizer-delivery',
    templateUrl: 'customizer-delivery.html',
    styleUrls: ['./_customizer-delivery.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class CustomizerDeliveryComponent {

	@Input() items: Array<AddressModel> = [];
	@Input() selectedIndex: number;
	@Output() selectedChange = new EventEmitter<number>();

	constructor() { }

	setSelected(index: number) {
		this.selectedChange.emit(index);
	}

}
